import { Model } from '@vuex-orm/core';

export default class Guest extends Model {
  static entity = 'guests';

  static fields() {
    return {
      id: this.attr(),

      primary: this.boolean(false),
      firstName: this.string(),
      lastName: this.string(),
      email: this.string(),
      phone: this.string(),
      address1: this.string(),
      address2: this.string(),
      city: this.string(),
      province: this.string(),
      postal: this.string(),
      country: this.string(),

      roomNumber: this.string(),
      hotelAddress: this.string(),
      hearAbout: this.string(),
      comments: this.string(),

      height: this.string(),
      weight: this.string(),
      birthday: this.string(),
      gender: this.string(),

      newsletter: this.boolean(),
      loyalty: this.boolean(),
      dataSharing: this.boolean()
    };
  }
}